@if (!loadingOrderPreparation) {
  <ul
    class="category-list">
    @for (category of productCategories; track category) {
      <li
        class="category-item">
        <span class="category-name">{{ category.name }}</span>
        <ul class="product-list">
          @for (product of category.products; track product) {
            <li
              class="product-item"
              [class.served-or-prepared]="product.status === 'State3_ServedOrPrepared'">
              <span class="product-name">{{ product.name }}</span>
              <span class="product-quantity">x{{ (product.quantity >= 10 ? '': ' ') + product.quantity }}</span>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
}
@if (loadingOrderPreparation) {
  <app-loader></app-loader>
}
